import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {IWinRatios} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {TimelineLite} from "gsap";

import {RocketWinPresentationEvent} from "../../event/RocketWinPresentationEvent";
import {TeslaParsedGameData} from "../../server/data/TeslaParsedGameData";
import {TeslaGameConfig} from "../../TeslaGameConfig";
import {TeslaSoundConfig} from "../../TeslaSoundConfig";
import {TeslaBigWinView} from "./TeslaBigWinView";

/**
 * Created by h3 on 2017-10-04.
 */

export class TeslaBigWinController extends WinPresentationController {
    private _winRatios:IWinRatios;
    private _playedBetValue:number;
    private _currentWinRatio:number;
    private _totalBigWinLevels:number;
    private _singleWin:number;

    private _timelineWinAnimation:TimelineLite | null;

    private _view:TeslaBigWinView;

    constructor(indexes:[number, number]) {
        super(indexes, {name : "BigWin", skippable : true});

        this._winRatios = TeslaGameConfig.instance.WIN_RATIOS;

        this._view = new TeslaBigWinView();
    }

    protected parseFeatureGameData(data:TeslaParsedGameData):void {
        this._playedBetValue = data.playedBetValue;
        this._currentWinRatio = data.currentWinRatio;
        this._singleWin = data.singleWin;

        if(data && data.isBigWin) {
            this._totalBigWinLevels = this.calculateBigWinLevel();
        }
    }

    protected hasWin():boolean {
        return this._gameData != null && this._gameData.isBigWin;
    }

    protected startWinPresentation():void {
        this._timelineWinAnimation = new TimelineLite();

        this.playWinAnimation(0, this._timelineWinAnimation);
    }

    private playWinAnimation(level:number, tl:TimelineLite):void {
        let countUpValues = this.calculateCountUpLevels(level);

        if(level <= this._totalBigWinLevels) {
            tl.add([
                this._view.getBigWinAnimation(level, countUpValues),
            ]);
            tl.eventCallback("onComplete", ()=>{
                this.playWinAnimation(level + 1, tl);
            });
        } else {
            this.finish();
        }
    }

    protected stopWinPresentation(isAborted:boolean):void {
        if(!isAborted) {
            const tl:TimelineLite = new TimelineLite();
            tl.add(() => this.playBigWinEndSound());
            tl.add(() => this._view.resetBigWinView(), "+=2");
        } else {
            this.playBigWinEndSound();
            this._view.resetBigWinView();
        }
        SlotGame.winFieldController.showWinField();

        if(this._timelineWinAnimation && this._timelineWinAnimation.isActive()) {
            this._timelineWinAnimation.kill();
            this._timelineWinAnimation = null;
        }

        EventHandler.dispatchEvent(new GameEvent(RocketWinPresentationEvent.BIG_WIN_PRESENTATIONS_STOPPED));
    }

    private calculateCountUpLevels(level:number):[number, number][] {
        let countUpValues:[number, number][] = [];


        for(let i:number = 0; i < this._winRatios.bigWin.length; i++) {
            let startValue:number = i === 0 ? 0 : this._playedBetValue * this._winRatios.bigWin[i].ratio;
            let toValue:number = i >= this._totalBigWinLevels ? this._singleWin : this._playedBetValue * this._winRatios.bigWin[i + 1].ratio;
            countUpValues.push([startValue, toValue]);
        }

        return countUpValues;
    }

    private calculateBigWinLevel():number {
        let level:number = 0;

        for(let i:number = 0; i < this._winRatios.bigWin.length; i++) {
            if(this._currentWinRatio > this._winRatios.bigWin[i].ratio) {
                level = i;
            }
        }
        return level;
    }

    private playBigWinEndSound() {

        const tl:TimelineLite = new TimelineLite();
        tl.add([
            () => SlotGame.sound.playEffect(TeslaSoundConfig.instance.BIG_WIN_END),
            () => SlotGame.sound.stopEffect(TeslaSoundConfig.instance.BIG_WIN_SMALL),
            () => SlotGame.sound.stopEffect(TeslaSoundConfig.instance.BIG_WIN_MEDIUM),
            () => SlotGame.sound.stopEffect(TeslaSoundConfig.instance.BIG_WIN_LARGE)

        ]);
        tl.add(() => SlotGame.sound.fadeAmbience(1.0, 3));

    }
}